import React, { useState } from 'react'
import style from './MenuCard.module.css'

/**
 * [Cards to menus]
 * @param  string  title
 * @param  function onClick
 * @param  Icon  image to show
 * @param  hasOnClick boolean to show hover cursor 
 * @return Menu Card
 */
const MenuCard = ({ text, onClick, Icon, hasOnClick = false }) => {

  const [isHover, setIsHover] = useState(false);


  return (
    <div className={style.content_card}
      onMouseLeave={() => setIsHover(false)}
      onMouseEnter={() => setIsHover(true)}>

      <div className={style.content_img_card} onClick={onClick}>
        <Icon className={style.img_card} />
      </div>

      <div className={style.content_name_card} onClick={onClick}>
        <div className={`${isHover?`${style.text_card_hover}`:''}  ${style.text_card}`}>
          {text}
        </div>
      </div>
    </div>
  )
}



export default MenuCard